import { FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';

type Props = {
  onCreated?: (area: LocationArea) => void;
};

export type LocationArea = {
  radius: number;
  mRadius: number;
  latitude: number;
  longitude: number;
};

const DrawTools = ({ onCreated }: Props) => {
  const _onCreated = (e: any) => {
    const type = e.layerType;
    const layer = e.layer;
    if (onCreated) {
      onCreated({ mRadius: layer._mRadius, radius: layer._radius, latitude: layer._latlng.lat, longitude: layer._latlng.lng });
    }
  };

  return (
    <FeatureGroup>
      <EditControl
        position='topleft'
        onCreated={_onCreated}
        draw={{
          rectangle: false,
          circlemarker: false,
          circle: true,
          polygon: false,
          polyline: false,
          marker: false
        }}
        edit= { { edit: false, remove: false, } }
      />
    </FeatureGroup>
  );
};

export default DrawTools;
